import * as ngCommon from '@angular/common'
import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../state'

/**
 * Allows the user to provide inputs to guide the writing assistant
 */
@ngCore.Component({
  imports: [ngCommon.NgTemplateOutlet, ds.input.textArea.Component],
  selector: 'atn-platform-writing-helper-pop-up',
  standalone: true,
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.writingHelper.Feature} */
  public readonly writingHelperFeature = ngCore.inject(
    state.writingHelper.Feature,
  )

  /**
   * Used if the user is editing a custom enhancement type
   */
  public readonly customEnhancementTypeSg = ngCore.signal<string>('')
}
